const SearchNotFound = (props) => {
  return (
    <p className='text-white text-3xl text-center'>We can't find your search.<br /> please search again.</p>
  );
}
export default SearchNotFound;